import ReactGA4 from "react-ga4";
import { mixpanelTrack } from "../../utils/mixpanel-track";
import { MixpanelEvent } from "../enums/mixpanel-event";

export const useTrackGoogleAnalyticsEvent = () => {
    return (category: string, action: string) => {
        ReactGA4.event({
            category: category,
            action: action,
        });
    };
};


export const useTrackGoogleAnalyticsEventPages = (pageValue:string='/',pageTitle:string='home'):void => {
    ReactGA4.send({ hitType: "pageview", page: pageValue, title: pageTitle });
    
    // Track page view in Mixpanel with proper properties
    mixpanelTrack(MixpanelEvent.page_view, {
        page_title: pageTitle,
        url_path: pageValue
    });
};
